export default class Teaser {

  constructor() {
    let _scope = this;

    this.teasers = document.querySelectorAll('.teaser-wrapper[data-teaser-type="20"].has-link');

    if(this.teasers.length) {
      for (let teaser of Array.from(this.teasers)) {
        _scope.init(teaser);
      }
    }
  }

  init(teaser) {
    let button = teaser.querySelectorAll('.text-wrapper > .button-wrapper a')[0];

    teaser.addEventListener('click', function (e) {
      if(e.target.tagName.toLowerCase() === 'a' && !e.target.classList.contains('button')) {
        return false;
      }

      button.click();
    });
  }
}